import { ComponentInterface, FunctionalComponent, h } from '@stencil/core';
import { transformTagNames } from '../../../global/transform-tag-name';

interface ControlsProps {
  controls: string;
}

const Controls = (that: ComponentInterface): FunctionalComponent<ControlsProps> => {
  const { WbIcon } = transformTagNames(that, 'wb-video', ['wb-icon']);

  return ({ controls }) => (
    <template id="controls">
      <div class="plyr__controls controls">
        {controls.includes('progress') && (
          <div class="plyr__controls__item plyr__progress__container progress">
            <div class="plyr__progress">
              <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" autocomplete="off" role="slider" aria-label="Seek" aria-valuemin="0" aria-valuemax="184" aria-valuenow="0" />
              <progress class="plyr__progress__buffer" max="100" role="progressbar" aria-hidden="true">
                % buffered
              </progress>
              <span class="plyr__tooltip">00:00</span>
            </div>
          </div>
        )}
        <div class="main">
          <div class="play">
            {controls.includes('play') && (
              <button class="plyr__controls__item plyr__control play-control" type="button" data-plyr="play" aria-pressed="false" aria-label="Play">
                <WbIcon class="icon--pressed" name="pause/24"></WbIcon>
                <WbIcon class="icon--not-pressed" name="media-play/24"></WbIcon>
                <span class="label--pressed plyr__sr-only">Pause</span>
                <span class="label--not-pressed plyr__sr-only">Play</span>
              </button>
            )}
            {controls.includes('current-time') && (
              <div class="time">
                <div class="plyr__time plyr__time--current" aria-label="Current time">
                  00:00
                </div>
                <div class="plyr__time plyr__time--duration" aria-label="Duration">
                  00:00
                </div>
              </div>
            )}
          </div>
          <div class="settings">
            {controls.includes('mute') && (
              <div class="plyr__controls__item plyr__volume volume">
                <button type="button" class="plyr__control plyr__control--pressed control" data-plyr="mute" aria-pressed="true">
                  <WbIcon class="icon--pressed" name="bds/volume-off/24"></WbIcon>
                  <WbIcon class="icon--not-pressed" name="bds/volume-up/24"></WbIcon>
                  <span class="label--pressed plyr__sr-only">Unmute</span>
                  <span class="label--not-pressed plyr__sr-only">Mute</span>
                </button>

                {controls.includes('volume') && <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="0" autocomplete="off" role="slider" aria-label="Volume" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" aria-valuetext="0.0%" />}
              </div>
            )}
            {controls.includes('captions') && (
              <button class="plyr__controls__item plyr__control control" type="button" data-plyr="captions" aria-pressed="false">
                <WbIcon class="icon--pressed" name="bds/message/24"></WbIcon>
                <WbIcon class="icon--not-pressed" name="bds/message/24"></WbIcon>
                <span class="label--pressed plyr__sr-only">Disable captions</span>
                <span class="label--not-pressed plyr__sr-only">Enable captions</span>
              </button>
            )}
            {controls.includes('fullscreen') && (
              <button class="plyr__controls__item plyr__control control" type="button" data-plyr="fullscreen" aria-pressed="false">
                <WbIcon class="icon--pressed" name="bds/fullscreen-exit/24"></WbIcon>
                <WbIcon class="icon--not-pressed" name="bds/fullscreen/24"></WbIcon>
                <span class="label--pressed plyr__sr-only">Exit fullscreen</span>
                <span class="label--not-pressed plyr__sr-only">Enter fullscreen</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </template>
  );
};

export { Controls as bindControls };
